import Table from "../UserInterface/Table";

const DataPembiayaan = {
  col: 2,
  heading: ["Jenis Biaya", "Jumlah"],
  content: [
    {
      items: ["Biaya administrasi", "Rp199.000"]
    },
    {
      items: ["Biaya pembayaran cicilan bulanan", "Rp10.000"]
    },
    {
      items: ["Biaya pelunasan awal", "Rp150.000"]
    }
  ]
};

const PembiayaanTable = () => {
  return <Table table={DataPembiayaan} tableTitle="Biaya Pembiayaan"></Table>;
};

export default PembiayaanTable;
